import { render, staticRenderFns } from "./CreateSaleOrder.vue?vue&type=template&id=2b5831e8&scoped=true"
import script from "./CreateSaleOrder.vue?vue&type=script&lang=js"
export * from "./CreateSaleOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateSaleOrder.vue?vue&type=style&index=0&id=2b5831e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5831e8",
  null
  
)

export default component.exports